import type { GameThemeId } from "@skillscratch/shared-types";

// storeMap.ts
export const standardRewards = {
  "0": 0,
  "1": 0,
  "2": 0,
  "3": 0,
  "4": 0,
  "5": 0,
  "6": 1_30,
  "7": 3_00,
  "8": 5_00,
  "9": 40_00,
  "10": 150_00,
};

const duneDollarRewards = {
  "0": 0,
  "1": 0,
  "2": 0,
  "3": 0,
  "4": 0,
  "5": 0,
  "6": 1_25,
  "7": 2_00,
  "8": 3_50,
  "9": 12_00,
  "10": 50_00,
};


export const storeListings = [
  {
    id: "payday-bonanza",
    name: "10X Payday Bonanza",
    gameThemeId: "payday-bonanza",
    prices: [
      {
        id: "payday-bonanza-1-1",
        totalCards: 1,
        bonus: 0,
        price: 15_00,
      },
      {
        id: "payday-bonanza-1-3",
        totalCards: 3,
        bonus: 200, // 2.00 bonus to account
        price: 45_00,
      },
      {
        id: "payday-bonanza-1-10",
        totalCards: 10,
        bonus: 500, // 5.00 bonus to account
        price: 150_00,
      },
    ],
    prizeAmount: 48500000,
  },
  {
    id: "the-money-mint",
    name: "The Money Mint",
    gameThemeId: "the-money-mint",
    prices: [
      {
        id: "money-mint-1-1",
        totalCards: 1,
        bonus: 0,
        price: 25_00,
      },
      {
        id: "money-mint-1-3",
        totalCards: 3,
        bonus: 200, // 2.00 bonus to account
        price: 75_00,
      },
      {
        id: "money-mint-1-10",
        totalCards: 10,
        bonus: 500, // 5.00 bonus to account
        price: 250_00,
      },
    ],
    prizeAmount: 55000000,
  },
  {
    id: "millionaire-maker",
    name: "Millionaire Maker",
    gameThemeId: "millionaire-maker",
    prices: [
      {
        id: "millionaire-maker-1-1",
        totalCards: 1,
        bonus: 0,
        price: 50_00,
      },
      {
        id: "millionaire-maker-1-3",
        totalCards: 3,
        bonus: 200, // 2.00 bonus to account
        price: 150_00,
      },
      {
        id: "millionaire-maker-1-10",
        totalCards: 10,
        bonus: 500, // 5.00 bonus to account
        price: 500_00,
      },
    ],
    prizeAmount: 126500000,
  },
  {
    id: "crazy-99s",
    name: "Crazy 99s",
    gameThemeId: "crazy-99s",
    prices: [
      {
        id: "crazy-99s-1-1",
        totalCards: 1,
        bonus: 0,
        price: 10_00,
      },
      {
        id: "crazy-99s-1-3",
        totalCards: 3,
        bonus: 200, // 2.00 bonus to account
        price: 30_00,
      },
      {
        id: "crazy-99s-1-10",
        totalCards: 10,
        bonus: 500, // 5.00 bonus to account
        price: 100_00,
      },
    ],
    prizeAmount: 9900000,
  },
  {
    id: "triple-cash-blast",
    name: "Triple Cash Blast",
    gameThemeId: "triple-cash-blast",
    prices: [
      {
        id: "triple-cash-blast-1-1",
        totalCards: 1,
        bonus: 0,
        price: 40_00,
      },
      {
        id: "triple-cash-blast-1-3",
        totalCards: 3,
        bonus: 200, // 2.00 bonus to account
        price: 120_00,
      },
      {
        id: "triple-cash-blast-1-10",
        totalCards: 10,
        bonus: 500, // 5.00 bonus to account
        price: 400_00,
      },
    ],
    prizeAmount: 85000000,
  },
  {
    id: "gold-card-15",
    name: "Gold Card",
    gameThemeId: "gold-card-15",
    prices: [
      {
        id: "gold-card-15",
        totalCards: 1,
        bonus: 0,
        price: 15_00,
      }
    ],
    prizeAmount: 25000,
  },
  {
    id: "gold-card-30",
    name: "Gold Card",
    gameThemeId: "gold-card-30",
    prices: [
      {
        id: "gold-card-30",
        totalCards: 2,
        bonus: 0,
        price: 30_00,
      }
    ],
    prizeAmount: 25000,
  },
  {
    id: "gold-card-60",
    name: "Gold Card",
    gameThemeId: "gold-card",
    prices: [
      {
        id: "gold-card-60",
        totalCards: 4,
        bonus: 0,
        price: 60_00,
      }
    ],
    prizeAmount: 25000,
  },
  {
    id: "gold-card-150",
    name: "Gold Card",
    gameThemeId: "gold-card-150",
    prices: [
      {
        id: "gold-card-150",
        totalCards: 10,
        bonus: 0,
        price: 150_00,
      }
    ],
    prizeAmount: 25000,
  },
  {
    id: "river-riches",
    name: "River Riches",
    gameThemeId: "river-riches",
    storeTags: ["10 scratches", "6x6 grid"],
    basePrice: 1_00,
    prices: [
      {
        id: "river-riches-1-5",
        totalCards: 5,
        bonus: 0,
        price: 5_00,
      },
      {
        id: "river-riches-1-10",
        totalCards: 10,
        bonus: 0,
        price: 10_00,
      },
      {
        id: "river-riches-1-25",
        totalCards: 26,
        bonus: 1,
        price: 25_00,
      },
      {
        id: "river-riches-1-50",
        totalCards: 52,
        bonus: 2,
        price: 50_00,
      },
      {
        id: "river-riches-1-100",
        totalCards: 105,
        bonus: 5,
        price: 100_00,
      },
    ],
    baseTreasures: 10,
    rewards: { ...standardRewards, "10": 1_000_00 },
    speedRewardCohortSize: 500_000,
    speedRewards: {
      "10": [12_500_00, 1_500_00, 750_00],
    },
    showInStore: true,
    allowTreasureInjections: true,
    prizeAmount: 1250000,
  },
  {
    id: "canyon-cash",
    name: "Canyon Cash",
    gameThemeId: "canyon-cash",
    storeTags: ["10 scratches", "6x6 grid"],
    basePrice: 3_00,
    prices: [
      {
        id: "canyon-cash-1-5",
        totalCards: 5,
        bonus: 0,
        price: 15_00,
      },
      {
        id: "canyon-cash-1-10",
        totalCards: 10,
        bonus: 0,
        price: 30_00,
      },
      {
        id: "canyon-cash-1-25",
        totalCards: 26,
        bonus: 1,
        price: 75_00,
      },
      {
        id: "canyon-cash-1-50",
        totalCards: 52,
        bonus: 2,
        price: 150_00,
      },
      {
        id: "canyon-cash-1-100",
        totalCards: 105,
        bonus: 5,
        price: 300_00,
      },
    ],
    baseTreasures: 10,
    rewards: { ...standardRewards, "10": 1_000_00 },
    speedRewardCohortSize: 500_000,
    speedRewards: {
      "10": [44_750_00, 5_000_00, 1_000_00],
    },
    showInStore: true,
    allowTreasureInjections: true,
    prizeAmount: 4475000,
  },
  {
    id: "blizzard-bucks",
    name: "Blizzard Bucks",
    gameThemeId: "blizzard-bucks",
    storeTags: ["10 scratches", "6x6 grid"],
    basePrice: 10_00,
    prices: [
      {
        id: "blizzard-bucks-1-5",
        totalCards: 5,
        bonus: 0,
        price: 50_00,
      },
      {
        id: "blizzard-bucks-1-10",
        totalCards: 10,
        bonus: 0,
        price: 100_00,
      },
      {
        id: "blizzard-bucks-1-25",
        totalCards: 26,
        bonus: 1,
        price: 250_00,
      },
      {
        id: "blizzard-bucks-1-50",
        totalCards: 52,
        bonus: 2,
        price: 500_00,
      },
      {
        id: "blizzard-bucks-1-100",
        totalCards: 105,
        bonus: 5,
        price: 1_000_00,
      },
    ],
    baseTreasures: 10,
    rewards: standardRewards,
    speedRewardCohortSize: 500_000,
    speedRewards: {
      "10": [225_500_00, 15_000_00, 2_500_00],
    },
    showInStore: true,
    allowTreasureInjections: true,
    prizeAmount: 2250000,
  },
  {
    id: "jungle-jackpot",
    name: "Jungle Jackpot",
    gameThemeId: "jungle-jackpot",
    storeTags: ["10 scratches", "6x6 grid"],
    basePrice: 25_00,
    prices: [
      {
        id: "jungle-jackpot-1-5",
        totalCards: 5,
        bonus: 0,
        price: 125_00,
      },
      {
        id: "jungle-jackpot-1-10",
        totalCards: 10,
        bonus: 0,
        price: 250_00,
      },
      {
        id: "jungle-jackpot-1-25",
        totalCards: 26,
        bonus: 1,
        price: 625_00,
      },
      {
        id: "jungle-jackpot-1-50",
        totalCards: 52,
        bonus: 2,
        price: 1_250_00,
      },
      {
        id: "jungle-jackpot-1-100",
        totalCards: 105,
        bonus: 5,
        price: 2_500_00,
      },
    ],
    baseTreasures: 10,
    rewards: standardRewards,
    speedRewardCohortSize: 500_000,
    speedRewards: {
      "10": [585_250_00, 25_000_00, 4_000_00],
    },
    showInStore: true,
    allowTreasureInjections: true,
    prizeAmount: 58525000,
  },
  {
    id: "mountain-millions",
    name: "Mountain Millions",
    gameThemeId: "mountain-millions",
    storeTags: ["10 scratches", "6x6 grid"],
    basePrice: 50_00,
    prices: [
      {
        id: "mountain-millions-1-5",
        totalCards: 5,
        bonus: 0,
        price: 250_00,
      },
      {
        id: "mountain-millions-1-10",
        totalCards: 10,
        bonus: 0,
        price: 500_00,
      },
      {
        id: "mountain-millions-1-25",
        totalCards: 26,
        bonus: 1,
        price: 1_250_00,
      },
      {
        id: "mountain-millions-1-50",
        totalCards: 52,
        bonus: 2,
        price: 2_500_00,
      },
      {
        id: "mountain-millions-1-100",
        totalCards: 105,
        bonus: 5,
        price: 5_000_00,
      },
    ],
    baseTreasures: 10,
    rewards: standardRewards,
    speedRewardCohortSize: 500_000,
    speedRewards: {
      "10": [1_265_000_00, 100_000_00, 10_000_00],
    },
    showInStore: true,
    allowTreasureInjections: true,
    prizeAmount: 126500000,
  },
  // {
  //   id: "dune-dollars-2",
  //   name: "Dune Dollars",
  //   gameThemeId: "dune-dollars",
  //   storeTags: ["10 scratches", "6x6 grid"],
  //   basePrice: 1_00,
  //   prices: [
  //     {
  //       id: "dune-dollars-2-5",
  //       totalCards: 5,
  //       bonus: 0,
  //       price: 10_00,
  //     },
  //     {
  //       id: "dune-dollars-2-10",
  //       totalCards: 10,
  //       bonus: 0,
  //       price: 20_00,
  //     },
  //     {
  //       id: "dune-dollars-2-25",
  //       totalCards: 25,
  //       bonus: 0,
  //       price: 50_00,
  //     },
  //     {
  //       id: "dune-dollars-2-50",
  //       totalCards: 50,
  //       bonus: 0,
  //       price: 100_00,
  //     },
  //   ],
  //   baseTreasures: 18,
  //   rewards: duneDollarRewards,
  //   speedRewardCohortSize: 500_000,
  //   speedRewards: {
  //     "10": [11_400_00, 1_000_00, 500_00],
  //   },
  //   showInStore: false,
  //   allowTreasureInjections: false,
  // },
  {
    id: "dune-dollars",
    name: "Dune Dollars 1",
    gameThemeId: "dune-dollars",
    storeTags: ["10 scratches", "6x6 grid"],
    basePrice: 1_00,
    prices: [
      {
        id: "dune-dollars-1-10",
        totalCards: 10,
        bonus: 0,
        price: 5_00,
        originalPrice: 10_00,
      },
      {
        id: "dune-dollars-1-20",
        totalCards: 20,
        bonus: 0,
        price: 10_00,
        originalPrice: 20_00,
      },
      {
        id: "dune-dollars-1-30",
        totalCards: 30,
        bonus: 0,
        price: 15_00,
        originalPrice: 30_00,
      },
    ],
    baseTreasures: 18,
    rewards: duneDollarRewards,
    speedRewardCohortSize: 500_000,
    speedRewards: {
      "10": [11_400_00, 1_000_00, 500_00],
    },
    showInStore: false,
    allowTreasureInjections: false,
    prizeAmount: 1140000,
  },
  {
    id: "coral-cash",
    name: "Coral Cash",
    gameThemeId: "coral-cash",
    storeTags: ["10 scratches", "6x6 grid"],
    basePrice: 25,
    prices: [
      {
        id: "sky-card-10",
        totalCards: 1,
        bonus: 0,
        price: 1_00,
      },
    ],
    baseTreasures: 22,
    rewards: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 2_40,
      "7": 2_80,
      "8": 3_20,
      "9": 3_60,
      "10": 4_00,
    },
    speedRewardCohortSize: 500_000,
    speedRewards: {
      "10": [478_00, 196_00, 86_00],
    },
    showInStore: false,
    isTutorial: true,
    onlySinglePurchase: true,
    allowTreasureInjections: false,
    prizeAmount: 100,
  },
  {
    id: "fortune-field",
    name: "Fortune Field",
    gameThemeId: "fortune-field",
    storeTags: ["10 scratches", "6x6 grid"],
    basePrice: 25,
    prices: [
      {
        id: "sky-card-11",
        totalCards: 1,
        bonus: 0,
        price: 1_00,
      },
    ],
    baseTreasures: 22,
    rewards: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 2_40,
      "7": 2_80,
      "8": 3_20,
      "9": 3_60,
      "10": 4_00,
    },
    speedRewardCohortSize: 1_000,
    speedRewards: {
      "10": [478_00, 196_00, 86_00],
    },
    showInStore: false,
    isTutorial: true,
    onlySinglePurchase: true,
    allowTreasureInjections: false,
    prizeAmount: 100,
  },
  {
    id: "sky-card",
    name: "Sky Card",
    gameThemeId: "sky-card",
    storeTags: ["10 scratches", "6x6 grid"],
    basePrice: 25,
    prices: [
      {
        id: "sky-card-12",
        totalCards: 1,
        bonus: 0,
        price: 1_00,
      },
    ],
    baseTreasures: 10,
    rewards: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 2_00,
      "7": 3_00,
      "8": 3_20,
      "9": 3_30,
      "10": 3_50,
    },
    speedRewardCohortSize: 1_000,
    speedRewards: {
      "10": [3_00, 3_00, 3_00],
    },
    showInStore: false,
    isTutorial: false,
    onlySinglePurchase: true,
    allowTreasureInjections: true,
    prizeAmount: 300,
  },
  {
    id: "dune-dollar",
    name: "Dune Dollars",
    gameThemeId: "dune-dollar" as unknown as GameThemeId,
    storeTags: ["10 scratches", "6x6 grid"],
    basePrice: 1_00,
    prices: [
      {
        id: "dune-dollars-2-5",
        totalCards: 5,
        bonus: 0,
        price: 10_00,
      },
      {
        id: "dune-dollars-2-10",
        totalCards: 10,
        bonus: 0,
        price: 20_00,
      },
      {
        id: "dune-dollars-2-25",
        totalCards: 25,
        bonus: 0,
        price: 50_00,
      },
      {
        id: "dune-dollars-2-50",
        totalCards: 50,
        bonus: 0,
        price: 100_00,
      },
    ],
    baseTreasures: 18,
    rewards: duneDollarRewards,
    speedRewardCohortSize: 500_000,
    speedRewards: {
      "10": [11_400_00, 1_000_00, 500_00],
    },
    showInStore: false,
    allowTreasureInjections: false,
    prizeAmount: 1140000,
  },
  {
    id: "gold-card",
    name: "Gold Card",
    gameThemeId: "gold-card",
    storeTags: ["10 scratches", "6x6 grid"],
    basePrice: 1_00,
    prices: [
      {
        id: "sky-card-13",
        totalCards: 1,
        bonus: 0,
        price: 1_00,
      },
    ],
    baseTreasures: 18,
    rewards: duneDollarRewards,
    speedRewardCohortSize: 1_000,
    speedRewards: {
      "10": [11_400_00, 1_000_00, 500_00],
    },
    showInStore: false,
    allowTreasureInjections: false,
    prizeAmount: 1140000,
  },
]

// Define types
export interface PriceOption {
  id: string;
  totalCards: number;
  bonus: number;
  price: number;
}

export interface StoreListing {
  id: string;
  name: string;
  gameThemeId: string;
  prices: PriceOption[];
  prizeAmount: number;
}

// Type for the map
export type StoreMap = {
  [key: string]: StoreListing;
};

// Create a map for O(1) lookup by ID
export const storeMap: StoreMap = storeListings.reduce<StoreMap>((map, listing) => {
  map[listing.id] = listing;
  return map;
}, {});

// Helper function for getting a store by ID with type safety
export const getStoreById = (id: string): StoreListing | null => storeMap[id] || null;

// Type for the price map
export type PriceMap = {
  [key: string]: PriceOption & { storeId: string };
};

// Create a map for O(1) lookup by price ID
export const priceMap: PriceMap = storeListings.reduce<PriceMap>((map, listing) => {
  for (const price of listing.prices) {
    map[price.id] = { ...price, storeId: listing.id };
  }
  return map;
}, {});

// Helper function for getting a price by ID with type safety
export const getPriceById = (id: string): (PriceOption & { storeId: string }) | null => 
  priceMap[id] || null;